import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/CoreStrengths.css";

const services = [
  {
    icon: "fas fa-balance-scale",
    title: "Corporate Law Advisory",
    description:
      "Practical corporate law guidance aligned with your organisation’s legal and commercial requirements.",
  },
  {
    icon: "fas fa-clipboard-check",
    title: "Secretarial Compliance Management",
    description:
      "Structured monitoring and management of statutory and secretarial compliance obligations.",
  },
  {
    icon: "fas fa-building",
    title: "Corporate Governance Framework",
    description:
      "Governance systems designed to improve accountability, transparency and responsible management.",
  },
  {
    icon: "fas fa-chart-line",
    title: "SEBI & Listing Regulations",
    description:
      "Professional support for listed entity compliance, disclosures and regulatory requirements.",
  },
  {
    icon: "fas fa-search",
    title: "Secretarial Audit",
    description:
      "Detailed review of statutory records, compliance procedures and corporate governance practices.",
  },
  {
    icon: "fas fa-file-signature",
    title: "Due Diligence",
    description:
      "Comprehensive legal and compliance assessment for investments, transactions and restructuring.",
  },
  {
    icon: "fas fa-globe-asia",
    title: "FEMA & RBI Compliance",
    description:
      "Advisory support for foreign investment, cross-border transactions and regulatory reporting.",
  },
  {
    icon: "fas fa-project-diagram",
    title: "Corporate Restructuring",
    description:
      "Strategic assistance for mergers, acquisitions, reorganisations and business restructuring.",
  },
  {
    icon: "fas fa-rocket",
    title: "Start-up & MSME Advisory",
    description:
      "Business-focused support for incorporation, compliance, funding readiness and sustainable growth.",
  },
  {
    icon: "fas fa-lightbulb",
    title: "Intellectual Property Services",
    description:
      "Advisory for trademarks, copyrights, brand protection and intellectual property strategy.",
  },
  {
    icon: "fas fa-stamp",
    title: "Regulatory Approvals",
    description:
      "End-to-end support for documentation, applications, filings and regulatory representation.",
  },
  {
    icon: "fas fa-gavel",
    title: "NCLT Matters",
    description:
      "Professional assistance for corporate petitions, proceedings and tribunal-related matters.",
  },
  {
    icon: "fas fa-tasks",
    title: "Compliance Outsourcing",
    description:
      "Reliable outsourced compliance management for businesses requiring continuous professional support.",
  },
  {
    icon: "fas fa-shield-alt",
    title: "Risk Management",
    description:
      "Identification and mitigation of legal, regulatory and corporate governance risks.",
  },
  {
    icon: "fas fa-leaf",
    title: "ESG & Sustainability Compliance",
    description:
      "Support for environmental, social and governance reporting, policies and compliance frameworks.",
  },
];

const CoreStrengths = () => {
  return (
    <section className="cs-section">
      <span className="cs-shape cs-shape-one"></span>
      <span className="cs-shape cs-shape-two"></span>

      <div className="container">
        <div className="cs-heading" data-aos="fade-up">
          <span className="cs-subtitle">Our Core Strengths</span>

          <h2>
            Professional excellence across every corporate compliance
            requirement.
          </h2>

          <p>
            We provide integrated corporate advisory, secretarial, governance
            and regulatory solutions designed to protect businesses and support
            sustainable growth.
          </p>
        </div>

        <div className="row g-3">
          {services.map((service, index) => (
            <div
              className="col-xl-3 col-lg-3 col-md-6"
              key={service.title}
              data-aos="fade-up"
              data-aos-delay={(index % 3) * 100}
            >
              <article className="cs-card">
                <div className="cs-card-header">
                  <span className="cs-icon">
                    <i className={service.icon}></i>
                  </span>

                </div>

                <h3>{service.title}</h3>

                <p>{service.description}</p>
                <span className="cs-card-line"></span>
              </article>
            </div>
          ))}
        </div>

       
      </div>
    </section>
  );
};

export default CoreStrengths;